angular.module('qkr').controller('TermsConditionsController', ($scope, $uibModalInstance, path) => {
	$scope.path = path;
	$scope.cancel = function() {
	    $uibModalInstance.dismiss('cancel');
	};
});



// WEBPACK FOOTER //
// ./src/controllers/modal/termsConditions.controller.js